import React, {useState} from 'react'
import {Button, Popconfirm} from "antd";
import OfferPrintContainer from "./print/OfferPrintContainer";
import {deleteOffer, cloneBid} from "../../services/serviceOffer";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";
import {Link} from "@reach/router";

const OfferActionsList = ({offerId, updater, popChange}) => {

    const [loadings, setLoadings] = useState([])


    const handleDeleteClick = () => {
        enterLoadingState(setLoadings)
        deleteOffer(offerId)
            .then(() => {
                exitLoadingState(setLoadings)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    const handleCloneClick = () => {
        cloneBid({id: offerId})
            .then(() => updater())
    }

    return(
        <React.Fragment>
            <Button
                type={"link"}
                onClick={popChange}
            >
                <Link to={`/landing/offer/update/${offerId}`}>Güncelle</Link>
            </Button>
            <Button
                type={"link"}
                onClick={popChange}
            >
                <Link to={`/landing/offer/detail/${offerId}`}>Detay</Link>
            </Button>
            <OfferPrintContainer offerId={offerId} popChange={popChange}/>
            <Popconfirm
                title={'Bu Kayıt İçin Revize Oluşturmak İstiyor musunuz ?'}
                okText={'Onayla'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'primary'}}
                onConfirm={handleCloneClick}
            >
                <Button
                    type={'link'}
                >
                    Revize
                </Button>
            </Popconfirm>
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger', loading: loadings[0]}}
                onConfirm={handleDeleteClick}
            >
                <Button type={"link"} danger>
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default OfferActionsList